import React, { createContext, useContext, useEffect, useState } from "react";
import { getTenantId } from "../api/ApiUtils";
import { getTenantConfig, getDefaultTenant } from "../config/tenantConfig";

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error("useTenant deve ser usado dentro de um TenantProvider");
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const [tenantId, setTenantId] = useState(null);
  const [tenantConfig, setTenantConfig] = useState(null);

  const applyTheme = (colors) => {
    const root = document.documentElement;
    root.style.setProperty("--adnwhite", colors.white);
    root.style.setProperty("--adndarkblue", colors.darkblue);
    root.style.setProperty("--adnblue", colors.blue);
    root.style.setProperty("--adnlightblue", colors.lightblue);
    root.style.setProperty("--adnlightestblue", colors.lightestblue);
    root.style.setProperty("--adngrey", colors.grey);
    root.style.setProperty("--adnlightgrey", colors.lightgrey);
    root.style.setProperty("--adnred", colors.red);
    root.style.setProperty("--adnorange", colors.orange);
    root.style.setProperty("--adngreen", colors.green);
  };

  const applyFavicon = (faviconPath) => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = faviconPath;
    if (!document.querySelector("link[rel*='icon']")) {
      document.getElementsByTagName("head")[0].appendChild(link);
    }
  };

  const loadTenant = () => {
    const currentTenantId = getTenantId();
    const finalTenantId = currentTenantId || getDefaultTenant();
    const config = getTenantConfig(finalTenantId);

    setTenantId(finalTenantId);
    setTenantConfig(config);
    applyTheme(config.colors);
    if (config.favicon) {
      applyFavicon(config.favicon);
    }
  };

  useEffect(() => {
    loadTenant();

    const intervalId = setInterval(() => {
      const currentTenantId = getTenantId();
      if (currentTenantId && currentTenantId !== tenantId) {
        loadTenant();
      }
    }, 1000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  const value = {
    tenantId,
    tenantConfig,
    refreshTenant: loadTenant,
  };

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  );
};
